import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import Commonpagination from "../../../Components/Tables/CommonPagination";
import Newcommontable from "../../../Components/Tables/NewCommonTable";
import NotificationReportsTable from "../../../Components/Tables/Reports/NotificationReportsTable";
import Loader from "../../../SharedComponents/Loader/Loader";
import classes from "../HomeScreen.module.css";
import { useDispatch, useSelector } from "react-redux";
import { AIreports } from "../../../Services/ApiServices";
import { toast } from "react-toastify";
import {
  CatchMessage,
  downloadUrl,
  HandleDeviceId,
  HandleMeterId,
  tokenisValid,
} from "../../../Shared/Methods";
import { handleloading } from "../../../Store/Redux/Reducers/Dashboardreducers";
import { useOutletContext } from "react-router-dom";
import AIReportsTable from "../../../Components/Tables/Reports/AIReportsTable";
import { DATE_FORMAT } from "../../../Shared/Constants";
import dayjs from "dayjs";
import FilterAIReport from "../../../Components/Filters/FilterAIReport";
import { HandleSessionModal } from "../../../Store/Redux/Reducers/Authreducers";

export default function AIReports() {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const [pageSize, setpageSize] = useState(20);
  const [pageind, setPageInd] = useState(0);
  const dispatch = useDispatch();

  const { showfilter, isDownload, setIsDownload, setShowFilter } =
    useOutletContext<{
      showfilter: boolean;
      isDownload: boolean;
      setIsDownload: Dispatch<SetStateAction<boolean>>;
      setShowFilter: Dispatch<SetStateAction<boolean>>;
    }>();
  const renderondeviceID = HandleDeviceId();
  const renderonmeterID = HandleMeterId();

  const { loading, alertType, rendernotificationpage } = useSelector(
    (state: any) => state.Dashboard
  );
  const [AiListData, setAiListData] = useState<any>([]);
  const { page, total_count, size } = AiListData;
  console.log(renderondeviceID?.deviceId, "renderondeviceID");

  useEffect(() => {
    if (LoginData !== null) {
      handleAiReports(1, 20);
    }
  }, [LoginData, renderondeviceID?.deviceId, renderonmeterID?.meter_id]);

  const handleAiReports = (page: number, pagesize: number) => {
    dispatch(handleloading(true));
    const formdata = new FormData();
    formdata.append("token", LoginData?.token);
    formdata.append("deviceId", renderondeviceID?.deviceId?.toString());
    formdata.append("meter_id", renderonmeterID?.meter_id?.toString());

    AIreports(page, pagesize, formdata)
      .then(async (response) => {
        if (response?.data?.status === 1) {
          setAiListData({
            ...response?.data?.data,
            items: [...response?.data?.data?.items].map((ele) => {
              return {
                ...ele,
                created_at: dayjs(ele?.created_at).format(DATE_FORMAT),
              };
            }),
          });
          setPageInd(page > 1 ? page - 1 : 0);
        } else if (response.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(response.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(response?.data?.error);
        }
      })
      .catch((error) => {
        CatchMessage(error);
      })
      .finally(() => {
        dispatch(handleloading(false));
        if (isDownload) {
          setIsDownload(false);
        }
      });
  };
  const Changesize = (current: number, size: number) => {
    setpageSize(size);
    handleAiReports(1, 10);
  };
  const ResetForm = () => {
    const emptyValues = {
      deviceId: "",
    };
    handleAiReports(1, size);
  };

  return (
    <>
      <Loader isLoader={loading} />
      <div className={classes.table_container_background}>
        {/* <FilterAIReport
          GetList={handleAiReports}
          ResetForm={ResetForm}
          pageSize={pageSize}
          showfilter={showfilter}
        /> */}
        <div>
          <h4>AI Reports</h4>
        </div>
        <Newcommontable
          Children={
            <AIReportsTable
              Data={AiListData}
              pageSize={pageSize}
              pageind={pageind}
              OBJHead={[
                "S.No",
                "Date",
                "Device Name",
                "Metter Name",
                "Alert Message",
              ]}
              OBJKeys={["created_at", "device_name", "meter_name", "alert_msg"]}
            />
          }
        />

        <Commonpagination
          onShowSizeChange={Changesize}
          PageSizeOptions={[20]}
          defaultPageSize={20}
          total={total_count}
          pageSize={size}
          current={page}
          onChange={(e, size) => {
            if (size === pageSize) {
              handleAiReports(e, size);
            }
          }}
        />
      </div>
    </>
  );
}
